import { Classes, Spinner } from "@blueprintjs/core";
import { IconName } from "@blueprintjs/icons";
import classnames from "classnames";
import { MouseEvent, PureComponent, useContext } from "react";
import styled, { css } from "styled-components";

import autobind from "autobind-decorator";
import { Intent } from "core/components/IntentContext";
import { IViewProps, View } from "core/decorators/View";
import VerticalCenter from "../../fragments/VerticalCenter";
import { toBlockCss } from "../common/BlockStylesConfig";
import { toTypographyCss } from "../common/TypographyStylesConfig";
import ColumnHeaderConfig from "./ColumnHeaderConfig";

export enum ColumnHeaderVariant {
	DEFAULT = "default",
}

interface IStyledHeaderProps {
	active?: boolean;
	config: ColumnHeaderConfig;
	disabled?: boolean;
}

const mapPropsToStyles = ({config}: IStyledHeaderProps) => css`
	display: flex;
	alignItems: center;
	text-decoration: none;
	color: inherit;
	border: 0;
	-webkit-appearance: none;
    -moz-appearance: none;
	${toTypographyCss(config.typography)}
	${toBlockCss(config.defaultState)}
	&:hover {
		${toBlockCss(config.hoverState)}
	}
`;

const StyledAnchorColumnHeader = styled.a<IStyledHeaderProps>(mapPropsToStyles);
const StyledHeader = styled.button<IStyledHeaderProps>(mapPropsToStyles);
const StyledSpan = styled.span<IStyledHeaderProps>(mapPropsToStyles);

export interface IColumnHeaderViewProps extends IViewProps<ColumnHeaderConfig, ColumnHeaderVariant> {
	icon?: string | IconName | JSX.Element;
	isActive?: boolean;
	loading?: boolean;
	onClick?: (e: any) => void;
	href?: string;
	disabled?: boolean;
	attrs?: any;
}

@View({ id: "columnHeader", configClass: ColumnHeaderConfig})
export class ColumnHeaderView extends PureComponent<IColumnHeaderViewProps> {

	@autobind
	private getChildren() {
		const { loading, children } = this.props;

		if(loading) {
			return (
				<Spinner size={Spinner.SIZE_SMALL} />
			);
		}

		return children;
	}

	public render() {
		const { attrs, config, isActive, onClick, disabled, style, intent } = this.props;

		const skeleton = Intent.LOADING === intent;
		const classes = classnames({active: isActive, [Classes.SKELETON]: skeleton});

		const props = {
			...attrs || {},
			children: (
				<VerticalCenter>
					{this.getChildren()}
				</VerticalCenter>
			),
			className: classes,
			active: isActive,
			config,
			disabled: skeleton || disabled,
			onClick,
			style
		};

		return (
			<StyledAnchorColumnHeader {...props} style={style} />
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/columnHeader/ColumnHeader.view.tsx